"use strict";

module.exports = {
  version: '10.2.1609'
};